import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    transform: theme.direction === 'rtl' && 'rotateY(180deg)',
  },
}));

export default useStyles;
